const { expect } = require('chai');
const { jpath } = require('jsonpath-mapper');
const { migratortronApi } = require('./migratortronApi');
const { loadRecordedMock } = require('./util');

const projectId = 'migratortronTarget';

describe('Delete nodes', () => {
  describe("preview deleting part of a project's node tree", () => {
    const mock = loadRecordedMock('delete_nodes_partial_preview.json');

    it(`should return a preview of nodes to delete`, (done) => {
      migratortronApi.post(
        'delete/nodes?partial',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);

          expect(body).to.be.an('object');
          if (body.error) done(body.error);

          expect(body?.existing?.[projectId]?.totalCount).to.equal(1);
          expect(body?.nodesToMigrate?.[projectId]?.delete).to.equal(1);
          done();
        }
      );
    });
  });

  describe("delete part of a project's node tree", () => {
    const mock = loadRecordedMock('delete_nodes_commit_partial.json');

    it(`should delete the nodes and return the results`, (done) => {
      migratortronApi.post(
        'delete/nodes/commit?partial',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);

          expect(body).to.be.an('object');
          if (body.error) done(body.error);

          expect(body?.existing?.[projectId]?.totalCount).to.equal(1);
          expect(body?.nodesResult.deleted).to.equal(1);
          expect(body?.nodesResult.updated).to.equal(0);
          // expect(body?.nodesResult.errors).to.not.exist;
          done();
        }
      );
    });
  });

  describe("repeat the same delete part of a project's node tree", () => {
    const mock = loadRecordedMock('delete_nodes_commit_partial_repeat.json');

    it(`should return an error saying the node at the path does not exist`, (done) => {
      migratortronApi.post(
        'delete/nodes/commit?partial&repeat',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);
          // This probably should be changed to return a 200 response with a formatted response
          expect(response.statusCode === 500);

          expect(body).to.be.an('object');
          expect(body.errors).to.exist;
          expect(body.errors).to.be.an('array');
          expect(body.errors[0].message).to.contain('does not exist');
          done();
        }
      );
    });
  });

  describe("preview deleting a project's node tree", () => {
    const mock = loadRecordedMock('delete_nodes_simple_preview.json');

    it(`should return a preview of nodes to delete`, (done) => {
      migratortronApi.post(
        'delete/nodes?simple',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);

          expect(body).to.be.an('object');
          if (body.error) done(body.error);

          expect(body?.existing?.[projectId]?.totalCount).to.be.greaterThan(1);
          expect(body?.nodesToMigrate?.[projectId]?.['no change']).to.equal(1);
          expect(body?.nodesToMigrate?.[projectId]?.delete).to.be.greaterThan(
            1
          );
          done();
        }
      );
    });
  });

  describe("delete a project's node tree", () => {
    const mock = loadRecordedMock('delete_nodes_commit_simple.json');

    it(`should delete the nodes and return the results`, (done) => {
      migratortronApi.post(
        'delete/nodes/commit?simple',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);

          expect(body).to.be.an('object');
          if (body.error) done(body.error);

          expect(body?.existing?.[projectId]?.totalCount).to.be.greaterThan(1);
          expect(body?.nodesToMigrate?.[projectId]?.['no change']).to.equal(1);
          expect(body?.nodesResult.deleted).to.be.greaterThan(1);
          expect(body?.nodesResult.errors).to.not.exist;
          done();
        }
      );
    });
  });

  describe("repeat the same delete a project's node tree", () => {
    const mock = loadRecordedMock('delete_nodes_commit_simple_repeat.json');

    it(`should return a node deletion preview with only the home node to update`, (done) => {
      migratortronApi.post(
        'delete/nodes/commit?simple&repeat',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);

          expect(body).to.be.an('object');
          if (body.error) done(body.error);

          expect(jpath('nodesToMigrate.*.totalCount', body)).to.equal(0);

          expect(body?.nodesResult.deleted).to.equal(0);
          expect(body?.nodesResult.updated).to.equal(0);
          expect(body?.nodesResult.errors).to.not.exist;
          done();
        }
      );
    });
  });
});
